import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'automationTemplate/system';

export function useSystemAutomationTemplatesQuery({
	enabled = true,
	industry,
	impersonationContext,
}: {
	enabled?: boolean;
	industry?: Api.Industry;
	impersonationContext?: Api.IImpersonationContext;
}) {
	const userSession = useUserSession();
	const queryParams: Record<string, string> = {};

	if (industry !== undefined) {
		queryParams.industry = industry;
	} else if (userSession?.account?.toJs().additionalInfo?.industry) {
		queryParams.industry = userSession.account.toJs().additionalInfo.industry;
	} else {
		queryParams.industry = Api.Industry.Miscellaneous;
	}

	return useQuery({
		enabled,
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<Api.IAutomationTemplate[]>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'automationTemplate/system',
					queryParams,
					impersonationContext,
				}),
				'GET'
			);
		},
		queryKey: [BASE_QUERY_KEY, queryParams.industry, impersonationContext?.account?.id],
	});
}

export function invalidateAllSystemAutomationTemplatesQueries() {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
}
